import { InputComponentType } from "../../../utils/enums";

export const getParticipantFields = (isAdd = false) => [
  {
    name: "employeeNum",
    label: "Employee #",
    required: true,
    component: InputComponentType.Dropdown,
  },
  {
    name: "courseNumber",
    label: "Course Number",
    component: InputComponentType.Dropdown,
    isDisabled: isAdd,
  },
  {
    name: "course",
    label: "Course",
    component: InputComponentType.TextField,
  },
  {
    name: "courseDate",
    label: "Course Date",
    component: InputComponentType.DatePicker,
  },
  {
    name: "attendedDate",
    label: "Attended Date",
    component: InputComponentType.DatePicker,
  },
  {
    name: "courseLocation",
    label: "Course Location",
    type: "text",
    component: InputComponentType.FreeTextDropdown,
  },
  {
    name: "dateRegistered",
    label: "Date Registered",
    component: InputComponentType.DatePicker,
  },
  {
    name: "hours",
    label: "Hours",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "grade",
    label: "Grade",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "approved",
    label: "Approved",
    component: InputComponentType.Checkbox,
  },
  {
    name: "checkSent",
    label: "Check Sent",
    component: InputComponentType.Checkbox,
  },
  {
    name: "dateCheckSent",
    label: "Check Sent Date",
    component: InputComponentType.DatePicker,
  },
  {
    name: "category",
    label: "Category",
    type: "text",
    component: InputComponentType.FreeTextDropdown,
  },
  {
    name: "approvedBy",
    label: "Approved By",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "comments",
    label: "Comments",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "participantNumber",
    label: "Participant #",
    type: "text",
    component: InputComponentType.TextField,
    isDisabled: (formValues) => !!formValues.id,
    isIdField: true,
  },
];
